import { Filter, Pagination, Sort } from "../interfaces/RequestBase";

export default function getFilter<F, S>(
	pagination: Pagination,
	filter: F | null = null,
	search: S | null = null,
	sort: Sort | null = null
): Filter<F, S> {
	var result: Filter<F, S> = { pagination };
	if (filter) result.filter_by = filter;
	if (search) result.search_by = search;
	if (sort) result.sort_by = sort;
	return result;
}

export function getIntersectionByKey(
	a: any[],
	b: any[],
	key: string = "id"
): any[] {
	return a.filter((x) => b.findIndex((y) => y === x[key]) !== -1);
}

export function getIntersection(a: any[], b: any[], key: string = "id"): any[] {
	return a.filter((x) => b.findIndex((y) => y[key] === x[key]) !== -1);
}

export function getUniqueByKey(a: any[], key: string = "id"): any[] {
	return a.filter((value, index) => a.indexOf(value) === index);
}
